import React from 'react';
import Layout from '../../common/Layout';
import { Formik } from 'formik';
import RouterPropsWrapper from '../../common/RouterPropsWrapper';
import { validateEditPassword } from '../Validations';
import ChangePasswordForm from "./ChangePasswordForm";
import Swal from 'sweetalert2';
import { auth } from "../../settings/firebase.js";
import { updatePassword } from 'firebase/auth'; 

function displayPasswordError(message = 'Error changing password.'){
  Swal.fire({
    type: 'error',
    text: message,
    showConfirmButton: false,
    showCancelButton: true,
    cancelButtonText: 'Close'
  })   
}

function displayPasswordChanged(){
  Swal.fire({
    type: 'success',
    title: 'Password Changed',
    showConfirmButton: false,
    timer: 1500
  })
}

const ChangePassword = (props) => {
  //const [id] = useState(props.match.params.id);
  
  const changePassword = async (values) => {
    if (values.password === values.password2) {
      const user = auth.currentUser;

      if (!user) {
        displayPasswordError('Utente non autenticato. Effettua il login.');
        props.history.push('/login');
        return;
      }

      try {
        await updatePassword(user, values.password);
        displayPasswordChanged();
        props.history.push(`/profile`);
      } catch (error) {
       
        // Gestisci errori specifici Firebase
        let errorMessage = 'Errore durante il cambio password';
        
        if (error.code === 'auth/requires-recent-login') {
          errorMessage = 'Per motivi di sicurezza, devi effettuare nuovamente il login prima di cambiare la password.';
          
          // Opzionale: Redirect al login
          setTimeout(() => {
            props.history.push('/login');
          }, 2000);
          
        } else if (error.code === 'auth/weak-password') {
          errorMessage = 'Password troppo debole. Deve essere di almeno 6 caratteri.';
        } else if (error.code === 'auth/invalid-password') {
          errorMessage = 'Password non valida.';
        } else {
          errorMessage = error.message || 'Errore durante il cambio password';
        }
        
        displayPasswordError(errorMessage);
      }
      
    } else {
      alert('Incorrect password confirmation');
    }
  }

  return (
    <Layout name="Change Password">
      <div className="wizard-container">
        <div className="col-md-8 col-12 mr-auto ml-auto">
          <div className="card card-wizard active" data-color="rose" id="wizardProfile">

            <Formik
              initialValues={{password:'',password2:''}}
              validate={validateEditPassword}
              onSubmit={(values, { setSubmitting }) => {
                setSubmitting(false);
                changePassword(values)
              }}
            >
              {({ isSubmitting, values, handleChange }) =>(
                <ChangePasswordForm
                  isSubmitting={isSubmitting}
                  values={values}
                  handleChange={handleChange}
                />
              )}

            </Formik>
          </div>
        </div>
      </div>
    </Layout>
  );
}

export default RouterPropsWrapper(ChangePassword);
